import React from 'react';
import { Redfin } from '../assets/icons';
import { percentage } from '../styles/GlobalStyles';

function RedfinAnalysis(props) {
    const redfinData = props.redfinData;
    const darkMode = props.darkMode;
    return (
        <div className="agentic-question-dilemma-container">
            {/* <span className={darkMode === true ? "body-bold colour-white" : "body-bold colour-secondary"}>
                Additional context:
            </span> */}
            <div className="agentic-question-redfin-container">
                <Redfin
                    className="agentic-question-redfin-icon"
                />
                <span className={darkMode === true ? "body-regular colour-tertiary" : "body-regular colour-secondary"}>
                    SFHs are <span className="body-bold">{redfinData.medianSalePriceYoY > 0 ? "up" : "down"} {percentage.format(Math.abs(redfinData.medianSalePriceYoY))}</span> YoY in {redfinData.zipcode} according to Redfin
                </span>
            </div>
        </div>
    )
};

export default RedfinAnalysis;